/*
 * wim-contact-popup.js
 *
 * Abre el popup de contacto reutilizando <popup-component> (base Broadcast).
 * Disparadores admitidos:
 *  - cualquier elemento con [data-wim-contact-open] (botón CONTACTAR de la PDP);
 *  - cualquier <a> cuyo href termine en el centinela #wim-contact-open (botón del
 *    Image banner u otra sección base que no admite data-attributes propios).
 * El popup vive en [data-wim-contact-popup]. Si no hay popup/form en la página,
 * no se hace nada y el enlace navega de forma nativa (fallback).
 *
 * Usa delegación de eventos a nivel de document (idempotente: tolera disparadores
 * duplicados como la barra sticky y no deja listeners por elemento). Guarda de doble
 * init para no registrar el handler más de una vez ante el Section Rendering API.
 */

(function () {
  'use strict';

  const INIT_FLAG = 'wimContactPopupInit';
  const TRIGGER_SELECTOR = '[data-wim-contact-open], a[href$="#wim-contact-open"]';

  if (document[INIT_FLAG]) return;

  /**
   * Resuelve el popup de contacto presente en el DOM.
   * @returns {Element|null}
   */
  const getPopup = () => document.querySelector('[data-wim-contact-popup]');

  /**
   * Maneja el click delegado sobre cualquier disparador de contacto.
   * @param {MouseEvent} event
   */
  const onClick = (event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    const popup = getPopup();

    // Sin popup/form en la página o componente aún sin upgrade: navegación nativa.
    if (!popup || typeof popup.popupOpen !== 'function') return;

    event.preventDefault();

    // Devuelve el foco al disparador (botón CONTACTAR) al cerrar. El base lee
    // window.a11y.lastElement en autoFocusLastElement(), mientras que su propio
    // handler de apertura escribe en window.theme.a11y.lastElement; seteamos
    // ambos para que el retorno de foco funcione sea cual sea el objeto leído.
    if (window.theme && window.theme.a11y) {
      window.theme.a11y.lastElement = trigger;
    }
    if (window.a11y) {
      window.a11y.lastElement = trigger;
    }

    // El <popup-component> base marca [closing] en el <dialog> al cerrar y no lo
    // limpia al reabrir; lo retiramos para que el estado de apertura sea limpio.
    const dialog = popup.querySelector('dialog');
    if (dialog) {
      dialog.removeAttribute('closing');
    }

    popup.popupOpen();
  };

  document.addEventListener('click', onClick);
  document[INIT_FLAG] = true;
})();
